"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _rtlDetect = require("rtl-detect");

var _toggle = _interopRequireDefault(require("./toggle.js"));

var _utilFunctions = require("./utilFunctions");

var _frameComponent = _interopRequireDefault(require("./frame-component.js"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CookieSettings = /*#__PURE__*/function (_FrameComponent) {
  _inherits(CookieSettings, _FrameComponent);

  var _super = _createSuper(CookieSettings);

  function CookieSettings() {
    var _this;

    _classCallCheck(this, CookieSettings);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "cookies", ['Preferences', 'Performance', 'Marketing']);

    _defineProperty(_assertThisInitialized(_this), "togglePreference", function () {
      var hasToggled = false;
      return function (section) {
        _this.setState(_defineProperty({}, section, !_this.state[section]), function () {
          (0, _utilFunctions.setCookie)(section, _this.state[section], _this.props.domain.toLowerCase());
        });

        if (!hasToggled) {
          hasToggled = true;
          (0, _utilFunctions.setCookie)(_constants.COOKIE_KEY_COOKIES_ACCEPTED, hasToggled, _this.props.domain.toLowerCase());
        }
      };
    });

    _defineProperty(_assertThisInitialized(_this), "toggleOverlay", function () {
      _this.setState({
        overlayOpen: !_this.state.overlayOpen
      });
    });

    _this.toggleHandler = _this.togglePreference().bind(_assertThisInitialized(_this));
    _this.state = {
      overlayOpen: false
    };

    _this.cookies.forEach(function (cookie) {
      return _this.state[cookie] = false;
    });

    return _this;
  }

  _createClass(CookieSettings, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.cookies.forEach(function (option) {
        var cookie = (0, _utilFunctions.__getCookie)(option);

        _this2.setState(_defineProperty({}, option, cookie === 'true'));
      });
    }
  }, {
    key: "renderContainerStyles",
    value: function renderContainerStyles(isRtl) {
      return "\n    a {\n      cursor: pointer;\n    }\n\n    .textarticle {\n      line-height: 1.5;\n      margin: 0 20px;\n      overflow-wrap: break-word;\n      overflow-x: hidden;\n   }\n   .textarticle-container {\n      margin: 0 auto;\n      max-width: 640px;\n      padding: 60px 0;\n   }\n    .textarticle-container > :first-child {\n      margin-top: 0;\n   }\n    .textarticle-container > :last-child {\n      margin-bottom: 250px;\n   }\n   .textarticle-container:first-letter {\n     text-transform: uppercase;\n   }\n    .textarticle h1 {\n      font-size: 40px;\n      font-weight: normal;\n      line-height: 1.25;\n      margin: 16px 0;\n      text-align: center;\n   }\n    .textarticle h1:first-child {\n      margin-top: 0;\n   }\n    .textarticle h1 + .textarticle-date {\n      margin: 30px 0 40px;\n      text-align: center;\n   }\n    .textarticle h1 + .textarticle-date-range {\n      margin-bottom: 60px;\n   }\n    .textarticle h1 + .textarticle-date + .textarticle-date {\n      margin-top: -40px;\n   }\n    .textarticle h2 {\n      font-size: 24px;\n      font-weight: 600;\n      line-height: 1.4166666667;\n   }\n    .textarticle h2 + h3 {\n      margin-top: -16px;\n   }\n    .textarticle h3, .textarticle h4, .textarticle h5, .textarticle h6 {\n      font-size: 16px;\n      font-weight: 600;\n   }\n   .textarticle p, .textarticle ol, .textarticle ul{\n      margin: 16px 0;\n   }\n    .textarticle hr {\n      border: none;\n      border-top: 1px solid #d4d4d4;\n      margin: 64px 0;\n   }\n    .textarticle-date {\n      font-weight: 500;\n      text-align: center;\n   }\n    .textarticle-date:last-child {\n      text-align: right;\n   }\n    .textarticle-overlay {\n      position: fixed;\n      top: 0;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      background: rgba(0, 0, 0, 0.7);\n      transition: opacity 500ms;\n      visibility: hidden;\n      opacity: 0;\n    }\n    .textarticle-overlay.open {\n      visibility: visible;\n      opacity: 1;\n    }\n    .textarticle-popup {\n      margin: 70px auto;\n      padding: 20px;\n      background: #fff;\n      border-radius: 5px;\n      width: 50%;\n      position: relative;\n      transition: all 5s ease-in-out;\n    }\n    .textarticle-close {\n      position: absolute;\n      top: 4px;\n      right: 20px;\n      transition: all 200ms;\n      font-size: 25px;\n      font-weight: bold;\n      text-decoration: none;\n      color: #333;\n    }\n    .textarticle-partnerlist {\n      max-height: 30%;\n    }\n\n    .toggle {\n      position: absolute;\n      display: inline-block;\n      width: 45px;\n      height: 23px;\n      box-sizing: border-box;\n      ".concat(isRtl ? 'left: 20px' : 'right: 20px', "\n    }\n    .toggle input {\n      display: none;\n    }\n    .slider {\n      position: absolute;\n      cursor: pointer;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      border: 1px solid #feed75;\n      background-color: #fcff07;\n      -webkit-transition: 0.4s;\n      transition: 0.4s;\n    }\n    .slider:before {\n      position: absolute;\n      border: 1px solid #aeb6bd;\n      content: \"\";\n      height: 19px;\n      width: 19px;\n      left: 21px;\n      bottom: 1px;\n      background-color: white;\n      -webkit-transition: 0.4s;\n      transition: 0.4s;\n      border-radius: 50%;\n    }\n    input:hover + .slider {\n      background-color: #feff7a;\n      border: 1px solid #feed75;\n    }\n    input[type=\"checkbox\"]:not(:checked) + .slider {\n      border: 1px solid #aeb6bd;\n      background-color: #aeb6bd;\n    }\n    input[type=\"checkbox\"]:not(:checked) + .slider:before {\n      -webkit-transform: translateX(-20px);\n      -ms-transform: translateX(-20px);\n      transform: translateX(-20px);\n    }\n    .slider.round {\n      border-radius: 1000px;\n    }\n    .section-headline {\n      display: flex;\n      align-items: center;\n      position: relative;\n    }\n    .section-headline h2 {\n      margin-right: 10px;\n    }\n    .section-copy .textarticle-button {\n      color: #3cb2e2;\n      text-decoration: underline;\n    }\n    .section-copy .third-party-advertiser a {\n      color: #3cb2e2;\n      text-decoration: underline;\n    }\n    ");
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var isRtl = (0, _rtlDetect.isRtlLang)(this.props.locale);
      var gettext = this.createStringSelector();
      var SECTIONS = gettext('COOKIE_SETTINGS_SECTIONS');
      var adPartnerList = gettext('AdvertisersList').map(function (partner, i) {
        return /*#__PURE__*/_react["default"].createElement("li", {
          className: "third-party-advertiser",
          key: i,
          dangerouslySetInnerHTML: {
            __html: partner
          }
        });
      });
      var sections = Object.keys(SECTIONS).map(function (section, i) {
        var thirdPartyAdvertiserCopy = SECTIONS[section].content[0].split(gettext('ThirdPartyAdvertisersText'));
        return /*#__PURE__*/_react["default"].createElement("section", {
          key: i,
          className: "section"
        }, /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement("div", {
          className: "cookie-settings-container"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "section-headline"
        }, /*#__PURE__*/_react["default"].createElement("h2", null, SECTIONS[section].headline), /*#__PURE__*/_react["default"].createElement(_toggle["default"], {
          key: section,
          onChange: function onChange() {
            return _this3.toggleHandler(section);
          },
          isToggled: _this3.state[section] || section === 'Necessary',
          disabled: section === 'Necessary'
        })), section === 'Marketing' ? /*#__PURE__*/_react["default"].createElement("div", {
          className: "section-copy"
        }, /*#__PURE__*/_react["default"].createElement("span", {
          dangerouslySetInnerHTML: {
            __html: thirdPartyAdvertiserCopy[0]
          }
        }), /*#__PURE__*/_react["default"].createElement("a", {
          className: "textarticle-button",
          onClick: _this3.toggleOverlay
        }, gettext('ThirdPartyAdvertisersText')), /*#__PURE__*/_react["default"].createElement("span", {
          dangerouslySetInnerHTML: {
            __html: thirdPartyAdvertiserCopy[1]
          }
        }), /*#__PURE__*/_react["default"].createElement("div", {
          id: "popup1",
          className: 'textarticle-overlay ' + (_this3.state.overlayOpen ? 'open' : '')
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "textarticle-popup"
        }, /*#__PURE__*/_react["default"].createElement("h2", null, gettext('ThirdPartyAdvertisersPopupText')), /*#__PURE__*/_react["default"].createElement("a", {
          className: "textarticle-close",
          onClick: _this3.toggleOverlay
        }, "\xD7"), /*#__PURE__*/_react["default"].createElement("div", {
          className: "textarticle-partnerlist"
        }, /*#__PURE__*/_react["default"].createElement("ul", null, adPartnerList))))) : SECTIONS[section].content.map(function (content) {
          return /*#__PURE__*/_react["default"].createElement("p", {
            className: "section-copy",
            dangerouslySetInnerHTML: {
              __html: content
            }
          });
        })));
      });
      return /*#__PURE__*/_react["default"].createElement("article", {
        className: "textarticle"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "textarticle-container"
      }, /*#__PURE__*/_react["default"].createElement("style", null, this.renderContainerStyles(isRtl)), /*#__PURE__*/_react["default"].createElement("h1", null, this.props.domain, " ", gettext('Title')), /*#__PURE__*/_react["default"].createElement("p", null, " ", gettext('Body')[0], " "), sections));
    }
  }]);

  return CookieSettings;
}(_frameComponent["default"]);

exports["default"] = CookieSettings;

_defineProperty(CookieSettings, "propTypes", {
  domain: _propTypes["default"].string.isRequired
});